import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
export default {
  mixins: [validationMixin],
  data: function data() {
    return {
      email: '',
      isProcessing: false
    };
  },
  activated: function activated() {
    this.$v.$reset();
  },
  methods: {
    closePopup: function closePopup() {
      this.$store.commit("setState", {
        key: "forgotPasswordIsActive",
        value: false
      });
    },
    showLogin: function showLogin() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.commit("setState", {
                  key: "forgotPasswordIsActive",
                  value: false
                });

              case 2:
                _this.$store.commit("setState", {
                  key: "loginIsActive",
                  value: true
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sendPasswordReset: function sendPasswordReset() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.$v.$touch();

                if (!_this2.$v.$invalid) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _this2.isProcessing = true;
                _context2.next = 7;
                return _this2.$swell.account.recover({
                  email: _this2.email,
                  reset_url: "".concat(window.location.origin, "/account/reset-password/?key={key}")
                });

              case 7:
                res = _context2.sent;
                _this2.isProcessing = false;

                if (res.success) {
                  _this2.flow = 'login';

                  _this2.$store.commit("setState", {
                    key: "forgotPasswordIsActive",
                    value: false
                  });

                  _this2.$store.dispatch('showNotification', {
                    message: _this2.$t('account.forgotPassword.success')
                  });
                }

                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                _this2.$store.commit("setState", {
                  key: "forgotPasswordIsActive",
                  value: false
                });

                _this2.$store.dispatch('showNotification', {
                  message: _this2.$t('account.forgotPassword.error'),
                  type: 'error'
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 12]]);
      }))();
    }
  },
  validations: {
    email: {
      required: required,
      email: email
    }
  }
};